export const USER_PREFERENCE_PLATFORM = 'internal_admin' as const;
export const USER_PREFERENCE_CLIENT = 'web' as const;

export type UserPreferencePlatform = typeof USER_PREFERENCE_PLATFORM;
export type UserPreferenceClient = typeof USER_PREFERENCE_CLIENT;
